export default __webpack_public_path__ + "static/media/login-bg-45.0d263386.jpg";